/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_It_Works__Hero__TitleInputs */

const en_how_it_works__hero__title = /** @type {(inputs: How_It_Works__Hero__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How BidBattles Works`)
};

/**
* | output |
* | --- |
* | "How BidBattles Works" |
*
* @param {How_It_Works__Hero__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const how_it_works__hero__title = /** @type {((inputs?: How_It_Works__Hero__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_It_Works__Hero__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_how_it_works__hero__title(inputs)
});